import React, { useEffect, useState } from 'react'
import CourseDetail from '../components/course-detail';
import CourseList from '../components/course-list';
import ClassList from '../components/class-list';
import ClassDetail from '../components/class-detail';
import { signOut } from 'firebase/auth';
import { auth, db } from '../firebase';
import { useNavigate } from 'react-router-dom';
import { Menu } from 'lucide-react';
import client from '../contentful';
import { doc, getDoc } from 'firebase/firestore';

export default function Home() {


  const [selectedCourse, setSelectedCourse] = useState(null);
  const [classes, setClasses] = useState([]);
  const [selectedClass, setSelectedClass] = useState(null);
  const [courses, setCourses] = useState({});
  const [refresh, setRefresh] = useState(false);
  const navigate = useNavigate();

  const handleOnRefresh = () => {
    setCourses({});
    setRefresh((prev) => !prev);
  }

  const disableRightClick = (event) => {
    // event.preventDefault();
  };

  useEffect(() => {
    const fetchCourses = async () => {
      try {

        const userRef = doc(db, 'users', auth.currentUser.email);
        const userSnap = await getDoc(userRef);
        console.log(userSnap.data());

        if (userSnap.exists()) {
          const userData = userSnap.data();
          const courseIds = userData.courses || [];

          if (courseIds.length === 0) {
            setCourses({});
            return;
          }
          const courseEntries = await client.getEntries({
            content_type: 'course',
            'sys.id[in]': courseIds.join(','),
          });

          const groupedCourses = {};
          
          courseEntries.items.forEach((courseEntry) => {
            const category = courseEntry?.fields?.category;
            const categoryName = category?.fields?.name ?? 'Uncategorized';
            const categoryOrder = category?.fields?.order ?? 0;
            if (!groupedCourses[categoryName]) {
              groupedCourses[categoryName] = {
                order: categoryOrder,
                courses:[]
              };
            }
            groupedCourses[categoryName].courses.push(courseEntry);
          });
          console.log(groupedCourses);
          setCourses(groupedCourses || {});
        } else {
          setCourses({});
          return;
        }
      } catch (error) {
        console.error('Error fetching courses:', error);
      }
    };

    fetchCourses();
  }, [refresh]);

  useEffect(() => {
    const disableF12 = (event) => {
      if (event.keyCode === 123) { // KeyCode for F12
        event.preventDefault();
      }
    };

    window.addEventListener('keydown', disableF12);

    return () => {
      window.removeEventListener('keydown', disableF12);
    };
  }, []);
  
  return (
    <div onContextMenu={disableRightClick} className="flex flex-col lg:flex-row h-screen gap-4 p-4">
      {/* Left side for detailed content */}
      <div className="flex-1 flex-center gap-4">
        <div className='w-full flex flex-row h-12 items-center gap-4'>

          <img onClick={() => { navigate("/") }} src="./assets/logo/app_without_text.png" alt="app logo" className='h-full cursor-pointer' />

          <h1 className='text-2xl font-bold text-nowrap title'>
            JS Tradventures
          </h1>
          <div className="flex-1" />

          <div className="w-auto drawer drawer-end lg:hidden">
            <input id="my-drawer-4" type="checkbox" className="drawer-toggle" />
            <div className="drawer-content">
              <label htmlFor="my-drawer-4" className="drawer-button btn btn-square btn-ghost">
                <Menu />
              </label>
            </div>
            <div className="drawer-side z-[500]">
              <label htmlFor="my-drawer-4" aria-label="close sidebar" className="drawer-overlay"></label>
              <div className="menu bg-base-100 min-h-full w-80 h-full">
                <div className='w-full p-6 overflow-y-auto h-full flex flex-col justify-between '>
                  {
                    Object.keys(courses).length < 1 ? (
                      <div className="flex-center  w-full h-full">
                        <div className="loading loading-md" />
                      </div>
                    ) :
                      classes.length > 0 ? (
                        <ClassList
                          setClasses={setClasses}
                          classes={classes}
                          setSelectedClass={setSelectedClass}
                          selectedClass={selectedClass}
                        />
                      ) :
                        (
                          <CourseList
                            onRefresh={handleOnRefresh}
                            courses={courses}
                            setClasses={setClasses}
                            setSelectedCourse={setSelectedCourse}
                            setSelectedClass={setSelectedClass}
                            selectedCourse={selectedCourse}
                          />
                        )
                  }
                  <br />
                  <button className="w-full btn btn-error btn-outline" onClick={async () => {
                    await signOut(auth);
                    navigate("/login");
                  }}>
                    Logout
                  </button>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div className='h-full overflow-y-auto w-full'>
          {!!selectedClass ? (
            <ClassDetail key={selectedClass.sys.id} selectedClass={selectedClass} />
          ) : !!selectedCourse ? (
            <CourseDetail course={selectedCourse} />
          ) : (
            <div className='flex-center flex-1 h-full gap-4'>
              <p className='text-center'>Please select a course from the list to get started.</p>
              <label htmlFor="my-drawer-4" className="drawer-button btn btn-outline lg:hidden">
                Choose Now
              </label>
            </div>
          )}
        </div>
      </div>

      {/* Right side for the list */}
      <div className="w-[calc(100% - 1rem)] hidden lg:flex lg:w-3/12 flex-col gap-4">
        <div className='border w-full p-6 lg:overflow-y-auto h-full'>
          {/* + "max-h-52 lg:max-h-none h-full" */}
          {
            courses.length < 1 ? (
              <div className="flex-center w-full h-full">
                <div className="loading loading-md" />
              </div>
            ) :
              classes.length > 0 ? (
                <ClassList
                  setClasses={setClasses}
                  classes={classes}
                  setSelectedClass={setSelectedClass}
                  selectedClass={selectedClass}
                />
              ) : (
                <CourseList
                  onRefresh={handleOnRefresh}
                  courses={courses}
                  setClasses={setClasses}
                  setSelectedCourse={setSelectedCourse}
                  setSelectedClass={setSelectedClass}
                  selectedCourse={selectedCourse}
                />
              )
          }
        </div>
        <button className="w-full btn btn-error btn-outline" onClick={async () => {
          await signOut(auth);
          navigate("/login");
        }}>
          Logout
        </button>
      </div>
    </div>
  );
}

